import React from 'react';

const ServicesPage = () => {
	  return (
		      <div style={{ padding: '100px 20px', textAlign: 'center' }}>
		        <h1>Our Services</h1>
		        <p>Explore our comprehensive realty solutions.</p>
		      </div>
		    );
};

export default ServicesPage;
